<acabim-datatable #archivedSiteDatatable [dataSources]="archivedSiteDataSources"
                  dataKey="id">
</acabim-datatable>

<acabim-modal [title]="actionTitle" [display]="displayDataModal" (status)="setModal($event)" [footer]="false"
>
    <div *ngIf="!isLoading else loading" class="p-d-flex flex-column">
        <div class="p-d-flex flex-row">
            <p>Do you really want to {{actionTitle}} the following site(s)?</p>
        </div>
        <div class="p-d-flex flex-row">

            <acabim-data-display [dataMap]="siteData" labelWidth="20rem"></acabim-data-display>

        </div>
        <div class="cas-action-buttons">
            <button (click)="siteAction(true)">PROCEED</button>
            <button (click)="siteAction(false)">CANCEL</button>
        </div>
    </div>

</acabim-modal>
<acabim-modal [display]="displayWarningModal" dontClose="true" [title]="'Message'" noPadding="true">
    <acabim-data-display [dataMap]="errorMessage"></acabim-data-display>
    <div class="cas-action-buttons">
        <button class="cas-button-action" (click)="closeErrorDialog()">OK</button>
    </div>
</acabim-modal>

<ng-template #loading>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
